import { MonthConvert, MonthConvert_year } from './utility';

const trimstre = {
  "first": 'Trimester pertama',
  'second': 'Trimester kedua',
  'third': 'Trimester ketiga'
};

const PeriodlenghSelect = ({ handleDateChange }) => {
  const options = [
    { value: 1, label: '1' },
    { value: 2, label: '2' },
    { value: 3, label: '3' },
    { value: 4, label: '4' },
    { value: 5, label: '5' },
    { value: 6, label: '6' },
    { value: 7, label: '7' },
    { value: 8, label: '8' },
    { value: 9, label: '9' },
    { value: 10, label: '10' },
  ];
  const handleSelectChange = (event) => {
    handleDateChange(event.target.value);
  };
  return (
    <div>
      <select id="PeriodLenth" onChange={handleSelectChange} className='form-control'>
        {options.map((option) => (
          <option key={option.value} value={option.value}>
            {option.label}
          </option>
        ))}
      </select>
    </div>
  );
};

const CyrcleLengthcomponet = ({ handleDateChange }) => {
  const options = [
    { value: 22, label: '22' },
    { value: 23, label: '23' },
    { value: 24, label: '24' },
    { value: 25, label: '25' },
    { value: 26, label: '26' },
    { value: 27, label: '27' },
    { value: 28, label: '28' },
    { value: 29, label: '29' },
    { value: 30, label: '30' },
    { value: 31, label: '31' },
    { value: 32, label: '32' },
    { value: 33, label: '33' },
    { value: 34, label: '34' },
    { value: 35, label: '35' },
    { value: 36, label: '36' },
    { value: 37, label: '37' },
    { value: 38, label: '38' },
    { value: 39, label: '39' },
    { value: 40, label: '40' },
    { value: 41, label: '41' },
    { value: 42, label: '42' },
    { value: 43, label: '43' },
    { value: 44, label: '44' },
  ];
  const handleSelectChange = (event) => {
    handleDateChange(event.target.value);
  };
  return (
    <div>
      <select id="CycleLength" onChange={handleSelectChange} className='form-control' style={{ width: '55px' }} defaultValue={28}>
        {options.map((option) => (
          <option key={option.value} value={option.value}>
            {option.label}
          </option>
        ))}
      </select>
    </div>
  );
};

const WeekSelectcomponet = ({ handleDateChange }) => {
  const options = [
    { value: 1, label: '1' },
    { value: 2, label: '2' },
    { value: 3, label: '3' },
    { value: 4, label: '4' },
    { value: 5, label: '5' },
    { value: 6, label: '6' },
    { value: 7, label: '7' },
    { value: 8, label: '8' },
    { value: 9, label: '9' },
    { value: 10, label: '10' },
    { value: 11, label: '11' },
    { value: 12, label: '12' },
    { value: 13, label: '13' },
    { value: 14, label: '14' },
    { value: 15, label: '15' },
    { value: 16, label: '16' },
    { value: 17, label: '17' },
    { value: 18, label: '18' },
    { value: 19, label: '19' },
    { value: 20, label: '20' },
    { value: 21, label: '21' },
    { value: 22, label: '22' },
    { value: 23, label: '23' },
    { value: 24, label: '24' },
    { value: 25, label: '25' },
    { value: 26, label: '26' },
    { value: 27, label: '27' },
    { value: 28, label: '28' },
    { value: 29, label: '29' },
    { value: 30, label: '30' },
    { value: 31, label: '31' },
    { value: 32, label: '32' },
    { value: 33, label: '33' },
    { value: 34, label: '34' },
    { value: 35, label: '35' },
    { value: 36, label: '36' },
    { value: 37, label: '37' },
    { value: 38, label: '38' },
    { value: 39, label: '39' },
    { value: 40, label: '40' },
  ];
  const handleSelectChange = (event) => {
    handleDateChange(event.target.value);
  };
  return (
    <div>
      <select id="Week" className='form-control' onChange={handleSelectChange}>
        {options.map((option) => (
          <option key={option.value} value={option.value}>
            {option.label}
          </option>
        ))}
      </select>
    </div>
  );
};

const DueDateTable = (result) => {
  return (
    <table>
      <thead>
        <tr>
          <th>Status</th>
          <th>Hasil</th>
        </tr>
      </thead>
      <tbody>
        <tr>
          <td>Perkiraan tanggal lahir</td>
          <td>{result.moneyAmout}</td>
        </tr>
        <tr>
          <td>Anda sedang dalam</td>
          <td>{result.currentWeek} ({result.numberOfWeeks} minggu dan {result.remainingDays} hari atau {result.months} bulan dan {result.daysMonth} hari) kehamilan.</td>
        </tr>
      </tbody>
    </table>
  );
};

const PregnancyConceptionTable = (Response) => {
  if (Response.Response === null) {
    return (<div></div>);
  } else {
    let response = Response.Response[0];
    return (
      <div>
        <p>Tanggal pembuahan yang paling mungkin:
          <b> {response.Most_probable_ConceptionWindowStart}</b> - <b>{response.Most_probable_ConceptionWindowEnd}</b>
        </p>
        <br />
        <p>Tanggal hubungan seksual yang paling mungkin menyebabkan kehamilan:
          <b> {response.Most_probable_DatesSexual_IntercourseStart}</b> - <b>{response.Most_probable_DatesSexual_IntercourseEnd}</b>
        </p>
        <p>Tanggal pembuahan yang mungkin:
          <b> {response.Possible_ConceptionWindowStart}</b> - <b>{response.Possible_ConceptionWindowEnd}</b>
        </p>
        <p>Tanggal hubungan seksual yang mungkin menyebabkan kehamilan:
          <b> {response.Possible_DatesSexual_IntercourseStart}</b> - <b>{response.Possible_DatesSexual_IntercourseEnd}</b>
        </p>
      </div>
    );
  }
};

const WeightGainPregnancyTable = (Response, CurrentWeight) => {
  if (Response.Response === null) {
    return (<div></div>);
  } else {
    let response = Response.Response;
    var range = "";
    var bmi = '';
    if (response.Weightclassification === 'higher') { range = "Berat badan Anda saat ini lebih tinggi dari rentang yang direkomendasikan."; }
    if (response.Weightclassification === 'lower') { range = "Berat badan Anda saat ini lebih rendah dari rentang yang direkomendasikan."; }
    if (response.Weightclassification === 'normal') { range = "Berat badan Anda saat ini berada dalam rentang yang direkomendasikan."; }
    if (response.BMIresult.BMIclassification === 'Underweight') { bmi = 'Berat badan kurang'; }
    if (response.BMIresult.BMIclassification === 'Normal weight') { bmi = 'Berat badan normal'; }
    if (response.BMIresult.BMIclassification === 'Overweight') { bmi = 'Kelebihan berat badan'; }
    if (response.BMIresult.BMIclassification === 'Obese') { bmi = 'Obesitas'; }
    return (
      <div>
        <p>
          Rentang berat badan yang direkomendasikan pada minggu ke-{response.Week}:
          <b> {response.Recommended.Max}</b> - <b>{response.Recommended.Min}</b>
          <br />
          {range}
        </p>
        <br />
        <p>
          Rentang berat badan yang direkomendasikan saat melahirkan (minggu ke-40):
          <b> {response.RecommendedWeightDelivering.Max}</b> - <b>{response.RecommendedWeightDelivering.Min}</b>
        </p>
        <br />
        <p>
          Indeks Massa Tubuh (IMT): &nbsp;
          <b>{response.BMIresult.BMI}</b> kg/m²&nbsp;
          ({bmi})
        </p>
      </div>
    );
  }
};

const PregnancyCalculatorTable = (Response) => {
  if (Response.Response === null) {
    return (<div></div>);
  } else {
    let response = Response.Response[0];
    return (
      <div>
        <p>
          Anda sedang dalam minggu ke-{response.CurrentWeek} ({response.NumberOfWeeks} minggu dan {response.remainingDays} hari atau {response.Months} bulan dan {response.DaysMonth} hari) kehamilan.
        </p>
        <p>
          Perkiraan tanggal lahir adalah:&nbsp;
          <b>{response.DueDate}</b>
        </p>
        <p>
          Kehamilan kemungkinan terjadi pada {response.conceived}
        </p>
        <p>
          {trimstre[response.Trimstre]} dari masa kehamilan, dan Anda telah menyelesaikan {response.Percentage}% dari total masa kehamilan
        </p>
      </div>
    );
  }
};

export { PeriodlenghSelect, CyrcleLengthcomponet, DueDateTable, PregnancyConceptionTable, WeekSelectcomponet, WeightGainPregnancyTable, PregnancyCalculatorTable };
